<script setup>
import { inject, onMounted, watch } from "vue"
import { useRoute } from "vue-router"
import { toast } from "vue3-toastify"
import "vue3-toastify/dist/index.css"

import ScrollToTop from "@core/components/ScrollToTop.vue"
import initCore from "@core/initCore"
import { initConfigStore, useConfigStore } from "@core/stores/config"
import { hexToRgb } from "@core/utils/colorConverter"
import { useTheme } from "vuetify"

const { global } = useTheme()

import DevToolsDetector from "@/aygulyazilim/components/DevToolsDetector.vue"
import { useAuthStore } from "@/aygulyazilim/store/useAuth"
import { useWebPush } from "@/composables/useWebPush"

const { servisWorkerKayit } = useWebPush()

// ℹ️ Sync current theme with initial loader theme
initCore()
initConfigStore()

const configStore = useConfigStore()
const socket = inject('socket')
const route = useRoute()

const authStore = useAuthStore()

const getPageName = () => route.name || route.path
const getDomain = () => window.location.hostname
const getPort = () => window.location.port || (window.location.protocol === 'https:' ? '443' : '80')

const emitOnlineStatus = () => {
  if (socket?.connected && authStore.user?.name) {
    socket.emit('user-online', {
      uuid: authStore.user.uuid,
      name: authStore.user.name,
      page: getPageName(),
      domain: getDomain(),
      port: getPort(),
    })
  }
}

onMounted(() => {
  servisWorkerKayit()

  if (socket) {
    socket.on('test_event', data => {
      // console.log('Test event received:', data)
      toast.info(data.message || 'Socket mesajı alındı!', {
        autoClose: 3000,
      })
    })

    socket.on('connect', () => {
      emitOnlineStatus()
    })

    if (socket.connected) {
      emitOnlineStatus()
    }
  } else {
    // console.error('Socket not injected!')
  }
})

// Kullanıcı bilgisi yüklenince tekrar gönder
watch(() => authStore.user?.name, name => {
  if (name && socket?.connected) {
    emitOnlineStatus()
  }
})

watch(() => route.name || route.path, newPage => {
  if (socket?.connected && newPage) {
    socket.emit('update-page', {
      page: newPage,
      domain: getDomain(),
      port: getPort(),
    })
  }
})
</script>

<template>
  <VLocaleProvider :rtl="configStore.isAppRTL">
    <DevToolsDetector />
    <!-- ℹ️ This is required to set the background color of active nav link based on currently active global theme's primary -->
    <VApp
      :style="`--v-global-theme-primary: ${hexToRgb(
        global.current.value.colors.primary
      )}`"
    >
      <RouterView />
      <ScrollToTop />
    </VApp>
  </VLocaleProvider>
</template>
